import { createFirebaseApp } from "@mattfinkel/common-web";
const handles = createFirebaseApp({
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
  appId: import.meta.env.VITE_FIREBASE_APP_ID,
});

export const firebaseApp = handles.firebaseApp;
export const auth = handles.auth;
export const googleProvider = handles.googleProvider;
